/**
 * Discriminator for the two kinds of allocation sheet surfaced in the Manage allocation sheets
 * list. Values are backend-aligned (`MANUAL_UPLOAD` and `DERIVED_RATIO`) so they can be used as
 * URL path segments, API discriminators, or form state without a translation layer. Display
 * labels live in `SHEET_KIND_LABELS` so UX copy can change without touching the enum.
 */
export enum SheetKind {
    MANUAL_UPLOAD = 'MANUAL_UPLOAD',
    DERIVED_RATIO = 'DERIVED_RATIO',
}

export const SHEET_KIND_LABELS: Record<SheetKind, string> = {
    [SheetKind.MANUAL_UPLOAD]: 'Manual',
    [SheetKind.DERIVED_RATIO]: 'Derived',
};
